import classnames from "classnames";
import * as React from "react";

import { Color, COLORS } from "../../consts";
import styles from "./CloseIcon.module.scss";

type Props = {
  color?: Color | null | undefined;
  onClick?: () => void;
  wrapperClassName?: string;
};

const CloseIcon = (props: Props) => {
  const { color, wrapperClassName, onClick } = props;
  return (
    <div
      className={classnames(styles.wrapper, wrapperClassName)}
      onClick={onClick}
    >
      <i
        className={classnames(styles.close, styles.icon, {
          [styles.white]: !color,
          [styles.grey]: color === COLORS.GREY
        })}
      />
    </div>
  );
};

export default CloseIcon;
